import React, { useMemo } from 'react';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import { useSelector } from 'react-redux';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import { activeSectionSelector } from '../../../../redux/pages/selectors';
import {
  OverviewTableData,
  createDeceasedTableData,
  ucitsOverviewCsvFields,
  useOverviewColumns,
} from './data';
import { RSOverviewPageModel } from '../../../../api/api.types';
import type { RiskOverviewMonitorFundRow } from '../../../../api/rs-hg/risk/riskOverview.types';
import { ReportsListByFund } from '../../../../api/rs-hg/risk/hooks/queries';

interface DeceasedTableProps {
  overviewData: RSOverviewPageModel<RiskOverviewMonitorFundRow[]>;
  reportsList: ReportsListByFund
}

const DeceasedTable: React.FC<DeceasedTableProps> = (props) => {
  const clientName = useSelector(clientNameSelector);
  const section = useSelector(activeSectionSelector);

  const columns: CustomColumn<OverviewTableData>[] = useOverviewColumns(
    clientName,
    section,
  );

  const data = useMemo(
    () =>
      createDeceasedTableData(
        props.overviewData.data,
        props.reportsList,
        null, // Putting null in for sub fund risk reports for now.
        clientName,
        section,
      ),
    [props.overviewData.data, props.reportsList, clientName, section],
  );
  return (
    <GridItem card xs={12}>
      <CustomTable<OverviewTableData>
        csvFields={ucitsOverviewCsvFields}
        showToolbar
        toolbarComponents={{
          toolbarTitle: 'Deceased Data',
        }}
        columns={columns}
        data={data}
        options={{
          paging: false,
          pageSize: 10,
          pageSizeOptions: [10, 20, data.length],
          search: true,
          exportButton: true,
          rowStyle: {
            padding: '0.62rem',
          },
        }}
      />
    </GridItem>
  );
};

export default DeceasedTable;
